"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _withTinyMcePopoverLifecycle = _interopRequireDefault(require("../hoc/withTinyMcePopoverLifecycle"));

var _EmojiPickerWrapper = _interopRequireDefault(require("ui-addon-emoji-picker/picker/EmojiPickerWrapper"));

var EmojiPickerPopover =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EmojiPickerPopover, _Component);

  function EmojiPickerPopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmojiPickerPopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmojiPickerPopover).call(this, props));
    _this.handleEmojiClick = _this.handleEmojiClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.setPopoverRef = _this.setPopoverRef.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EmojiPickerPopover, [{
    key: "setPopoverRef",
    value: function setPopoverRef(c) {
      this.popoverRef = c;
    }
  }, {
    key: "handleEmojiClick",
    value: function handleEmojiClick(emoji) {
      var onInsertEmoji = this.props.onInsertEmoji;
      onInsertEmoji(emoji);
      this.popoverRef.focus(); // Allows for consecutive inserts
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          className = _this$props.className,
          addTargetClasses = _this$props.addTargetClasses,
          pinToConstraint = _this$props.pinToConstraint,
          onRemove = _this$props.onRemove,
          children = _this$props.children,
          storeHandlers = _this$props.storeHandlers,
          EmojiPicker = _this$props.EmojiPicker;
      var popoverProps = {
        open: isOpen,
        className: className,
        addTargetClasses: addTargetClasses,
        pinToConstraint: pinToConstraint,
        autoPlacement: true,
        animateOnToggle: false,
        arrowSize: 'none',
        placement: 'bottom right',
        closeOnOutsideClick: true,
        onOpenChange: onRemove
      }; // TODO: Add onSelect prop, notFound custom emoji when emoji-mart bender-repackage is updated

      return _react.default.createElement(_EmojiPickerWrapper.default, {
        ref: this.setPopoverRef,
        native: true,
        autoFocus: true,
        onClick: this.handleEmojiClick,
        popoverProps: popoverProps,
        useDefaultFilter: true,
        unicodeVersion: 8.0,
        storeHandlers: storeHandlers,
        PickerContent: EmojiPicker
      }, children);
    }
  }]);
  return EmojiPickerPopover;
}(_react.Component);

EmojiPickerPopover.propTypes = {
  EmojiPicker: _react.PropTypes.func.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  onRemove: _react.PropTypes.func.isRequired,
  onInsertEmoji: _react.PropTypes.func.isRequired,
  storeHandlers: _react.PropTypes.shape({
    getter: _react.PropTypes.func,
    setter: _react.PropTypes.func
  }),
  children: _react.PropTypes.object,
  className: _react.PropTypes.string,
  addTargetClasses: _react.PropTypes.bool,
  pinToConstraint: _react.PropTypes.array
};

var _default = (0, _withTinyMcePopoverLifecycle.default)(EmojiPickerPopover);

exports.default = _default;
module.exports = exports.default;